import React from 'react';
import {withRouter} from 'react-router';
import config from '../../assets/js/conf/config.js';
import {localParam} from '../../assets/js/utils/util.js';
import '../../assets/css/common/tags.css';
class TagsComponent extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            status:localParam(this.props.location.search).search.status?localParam(this.props.location.search).search.status:""
        }
    }
    componentDidMount(){

    }
    componentWillUnmount(){
        this.setState=(state,callback)=>{
            return;
        }
    }
    componentWillReceiveProps(newProps){
        this.setState({status:localParam(newProps.location.search).search.status});
    }
    replacePage(url){
        this.props.history.replace("/transfer");
        setTimeout(()=>{
            this.props.history.replace(url);
        },10);
    }
    render(){
        return (
        	<div className={'video-content'}>
	    		<div className={this.state.status === '1'?'active':''} onClick={this.replacePage.bind(this, "/video/detail?status=1")}>
	        		详情
	        		<span></span>
	        	</div>
	    		<div className={this.state.status === '2'?'active':''} onClick={this.replacePage.bind(this, "/video/other?status=2")}>
	        		互动
	        		<span></span>
	        	</div>
	        </div>
        );
    }
}
export default withRouter(TagsComponent);